import { Button, FormHelperText } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { SettingsWrapper } from "../SettingsWrapper";
import { CurrentPlanSkeleton } from "../CurrentPlanSkeleton";
import { useAppSelector } from "../../../../store/hooks";
import { CurrentPlanCard } from "../CurrentPlanCard";
import { useGetCancelSubscriptionLink } from "../../../../hooks/useGetCancelSubscriptionLink";
import { selectExtension } from "../../../../features/extension/extension.selector";
import { FONT_COLORS } from "../../../../constants";
import { isStoreManagedSubscription } from "../../../../helpers";

export const CurrentPlan = () => {
  const { user, loading: userLoading } = useAppSelector((state) => state.user);
  const { data: pricingPlans, isLoading: pricingPlansLoading } = useAppSelector(
    (state) => state.pricingPlans,
  );

  const navigate = useNavigate();

  const currentPlan = pricingPlans?.find(
    (plan) => plan.planId === user?.planDetails?.planId,
  );
  const isStoreManaged = isStoreManagedSubscription(user?.store);
  // cancelAt is a real date string when cancellation is pending but not yet expired
  const isCancellationPending = !!user?.cancelAt && user.cancelAt !== "null";
  const { isExtension } = useAppSelector(selectExtension);
  const {
    getLink,
    error: getLinkError,
    loading: getLinkLoading,
  } = useGetCancelSubscriptionLink({
    onSuccess: (link) => {
      window.open(link, isExtension ? "_blank" : "_self");
    },
  });

  return (
    <SettingsWrapper
      heading="Current Plan"
      subHeading="You can update your plan anytime for best benefit from the product"
      renderButton={
        isStoreManaged
          ? undefined
          : (props) => (
              <>
                <Button
                  {...props}
                  onClick={() => navigate("/account/subscriptions")}
                >
                  Switch Plan
                </Button>
                &nbsp;&nbsp;
                <Button
                  {...props}
                  onClick={getLink}
                  loading={getLinkLoading}
                  sx={
                    isCancellationPending
                      ? undefined
                      : { color: FONT_COLORS.error }
                  }
                >
                  {!isCancellationPending && "Cancel Plan"}
                </Button>
              </>
            )
      }
    >
      {userLoading || pricingPlansLoading ? (
        <CurrentPlanSkeleton />
      ) : !currentPlan ? (
        <FormHelperText error>Failed to show current plan</FormHelperText>
      ) : (
        <CurrentPlanCard
          plan={currentPlan}
          nextPaymentDate={user?.planDetails.nextPaymentDate}
          nextPlanId={user?.planDetails.nextPlanId}
        />
      )}
    </SettingsWrapper>
  );
};
